import { createFileRoute, redirect } from '@tanstack/react-router';
import { ChangePasswordPage } from '@portal/ui';
import { DealerShell } from '@/components/shell';

/**
 * `/reset-password` without a token: the logged-in user's "change password" (the user menu links
 * here); anyone else wants a reset link, as in Angular. Outside `_app` so an anonymous visitor goes
 * to `/forgot-password` rather than to the login page.
 */
export const Route = createFileRoute('/reset-password/')({
  beforeLoad: ({ context }) => {
    if (context.session.status !== 'authenticated') {
      throw redirect({ href: '/forgot-password' });
    }
  },
  component: () => (
    <DealerShell>
      <ChangePasswordPage />
    </DealerShell>
  ),
});
